export default function (state, data) {
  state.Number = data.Number;
  state.IssueDate = data.IssueDate.Serialized;
  state.StartDate = data.StartDate.Serialized;
  state.EndDate = data.EndDate.Serialized;
  state.ContragentId = '';
  state.PartnerLegalId = '';
  state.ContragentName = '';
  state.ContragentType = '';
  state.OwnerLegalEntityId = data.OwnerLegalEntityId;
  state.CurrencyId = data.CurrencyId;
  state.Type = data.Type;
  state.IsPayed = data.IsPayed;
  state.IsUsed = data.IsUsed;
  state.Id = data.Id;
  state.Sum = data.Sum;
  state.SumOld = data.Sum;
  state.ParentNumber = data.ParentNumber;
  state.PartnerId = data.PartnerId;
  state.Balance = data.Balance;
  state.UsersSum = data.UsersSum;
  state.Comment = data.Comment ? data.Comment : '';
  if (data.CreateDate && data.CreateDate.Serialized) state.CreateDate = data.CreateDate.Serialized;
  state.CreatorName = data.CreatorName;

  if (data.ClientId) {
    state.ContragentId = data.ClientId;
    state.ContragentName = data.ClientName;
    state.ContragentType = 1;
  }
  if (data.PartnerId) {
    state.ContragentId = data.PartnerId;
    state.ContragentName = data.PartnerName;
    state.ContragentType = 2;
    state.PartnerLegalId = data.PartnerLegalId ? data.PartnerLegalId : '';
  }
}
